"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("../utils/prop-types"));

var _filterListItem = _interopRequireDefault(require("./filter-list-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FilterList = function FilterList(props) {
  var ItemView = props.filterListItemView;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.settings.Filters.length === 0 && null, props.settings.Filters.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-list"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "close-button",
    onClick: function onClick(e) {
      props.onCloseFilterList(e);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-list-title"
  }, props.settings.dictionary.filterTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-list-filters"
  }, props.settings.Filters.map(function (filter, index) {
    return _react["default"].createElement(ItemView, Object.assign({
      key: "filterItem-".concat(filter.id),
      filter: filter,
      index: index
    }, props));
  }))));
};

var _default = FilterList;
exports["default"] = _default;
FilterList.propTypes = {
  filterListItemView: _propTypes["default"].func,
  onCloseFilterList: _propTypes["default"].func,
  settings: _propTypes["default"].settings
};
FilterList.defaultProps = {
  filterListItemView: _filterListItem["default"],
  onCloseFilterList: _propTypes["default"].defaultOnCloseFilterList,
  settings: _propTypes["default"].defaultSettings
};